import { render, staticRenderFns } from "./ManagerTicketsTable.vue?vue&type=template&id=be962436&scoped=true"
import script from "./ManagerTicketsTable.vue?vue&type=script&lang=js"
export * from "./ManagerTicketsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be962436",
  null
  
)

export default component.exports